export default {
  label: {
    title: 'Acceso al dashboard',
    button: {
      cancelButton: 'Cancelar',
      confirmButton: 'Acceder',
    },
    form: {
      title: 'E-mail *',
      agreeTerms: {
        messageFirstPart: 'Li y acepto los ',
        messageSecondPart: 'y la',
        useTerms: 'érminos de Uso',
        privacyPolicy: 'Política de Privacidad',
      },
      error: {
        addEmail: 'El e-mail es obligatorio.',
      },
    },
  },
};
